import { useTranslationInterface } from 'utils/hooks/useTranslation';

// strings for this module are in src/services/i18n/en-us/creativeLibrary.json

export const useTranslations = () => useTranslationInterface('creativeLibrary');
